let messageConfig = {
    806: `아이디 또는 비밀번호가 틀립니다.\n 선생님께 문의하세요.`,
    853: `해당 계정은 휴면 상태입니다.\n 재이용을 원하시면 선생님께 문의해 주세요.`,
    854: `해당 계정은 학습중단 상태입니다.\n 재이용을 원하시면 선생님께 문의해 주세요.`,
    861: `해당 계정은 퇴회 처리되어\n 더 이상 서비스를 이용할 수 없습니다.\n 재이용을 원하시면 선생님께 문의해 주세요.`,
    867: `중복로그인으로 인해 자동으로<br/>  로그아웃 되었습니다.`,
    810: `장시간 활동이 없어 자동으로<br/> 로그아웃 되었습니다.`,
};

export default messageConfig;
